import React from 'react';
import { Redirect } from 'react-router';
import RoutePath from './../App/RoutePath';

const SosRedirect = () => <Redirect to={RoutePath.Help} />;

export default SosRedirect;
